import { Component, OnInit } from '@angular/core';
import {
  ProductWhereToShopListResponse,
  ProductWhereToShopListResponseCategory,
} from 'src/app/api/client/models';
import { WhereToShopService } from 'src/app/api/client/services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-where-to-shop',
  templateUrl: './where-to-shop.component.html',
  styleUrls: ['./where-to-shop.component.scss'],
})
export class WhereToShopComponent implements OnInit {
  selectedChip = 1;

  stores: ProductWhereToShopListResponseCategory[] = [];
  activeList: ProductWhereToShopListResponseCategory[] = [];

  public response: ProductWhereToShopListResponse | undefined = undefined;

  constructor(private api: WhereToShopService) {}

  public loading = false;

  buildActiveList() {
    if (this.selectedChip == -1) {
      this.activeList = [...this.stores];
    } else {
      this.activeList = [
        this.stores.find(
          (x: ProductWhereToShopListResponseCategory) =>
            x.categoryID == this.selectedChip
        )!,
      ];
    }
  }

  async ngOnInit(): Promise<void> {
    this.response = await this.api
      .v1WhereToShopPost$Json({
        body: {
          productId: 'e71fc875f5f644b79a7660d3cbaf3c04',
        },
      })
      .toPromise();

    if (this.response.categories) {
      this.stores = [...this.response.categories!];
    }

    this.buildActiveList();
  }

  async click(placementId: string, url: string) {
    window.open(url, '_blank');
    await this.api
      .v1WhereToShopClickPost({
        body: {
          placementId: placementId,
          sourceId: environment.zeropay.sourceId,
          customerId: '',
        },
      })
      .toPromise();
  }
}
